import { useAuthStore } from '@avanta/shared/stores/auth';
import { type ReactNode, type ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router';
import { PRIVATE_ROUTES, ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';
import { TrackingEventsType, DeviceType } from 'types/tracking';
import { useTracking } from './hooks/useTracking';

const routeEventMap: Record<string, TrackingEventsType> = {
  [ROUTES.APPOINTMENTS_RESERVE]: TrackingEventsType.USER_OPEN_APPOINTMENT_BOOKING_PAGE,
  //TODO Ver con @isawebcode
  // [ROUTES.REGISTER]: TrackingEventsType.USER_SIGN_UP_STARTED,
  [ROUTES.HOME]: TrackingEventsType.USER_ENTERS,
};

export function TrackingProvider({ children }: { children: ReactNode }): ReactElement {
  const location = useLocation();
  const { track } = useTracking();
  const authInfo = useAuthStore(state => state.authInfo);
  const userId = useUserStore(state => state.user?.id);

  useEffect(() => {
    const pathname = location.pathname;
    const event = routeEventMap[pathname];

    if (!event) return;

    const isPrivateRoute = Object.values(PRIVATE_ROUTES).includes(pathname);
    if (isPrivateRoute && !authInfo) return;
    if (isPrivateRoute && !userId) return;

    const isAnonymousRoute = pathname === ROUTES.REGISTER;

    track(
      event,
      {
        ...(userId && { userId }),
        landingPage: pathname,
        deviceType: /Mobi/i.test(navigator.userAgent) ? DeviceType.MOBILE : DeviceType.DESKTOP,
      },
      isAnonymousRoute
    );
  }, [location.pathname, track, authInfo, userId]);

  return <>{children}</>;
}
